import React, { useEffect, useState } from 'react';
import { TASK_TYPES } from '../../../utils/constants';
import { MultipleChoiceOption, MultipleChoiceImageOption } from './';
import { YouTubeVideo } from './YouTubeVideo';

export const MultipleChoice = ({completed, setCompleteEnabled, setCorrect, task}) => {
  const [activeRadio,setActiveRadio] = useState(null);

  // reset when two MC's are rendered twice in a row
  useEffect(() => {
    setActiveRadio(null)
  }, [task])
  
  const handleChange = (i) => {
    setActiveRadio(i)
    setCompleteEnabled(true)
    setCorrect(isCorrect(i))
  }

  const isCorrect = (optIndex) => { 
    // regrettably, the XML "true"/"false" is a string, not bool
    return task.OPTION[optIndex].$.correct.toLowerCase() === "true";
  }


  const getOptionMods = (i) => {
    let mods = '';

    // after task is over
    if (completed) {
      // correct answer is green no matter what
      if (isCorrect(i)) {
        mods = 'task__option--success'
      }
      // if this was selected, but not correct, it's red 
      else if (activeRadio === i) {
        mods = 'task__option--failure'
      }
    }
    // just selected
    else if (activeRadio === i) {
      mods = 'task__option--active'
    } 

    return mods;
  }

  return (
    <>

      <fieldset className={`task task--${task.$.type.toLowerCase()}`}>
        
        <legend className="task__text">{task.TEXT[0]}</legend>
        
        { task.$.type === TASK_TYPES.MCV &&
          <div className="task__video-wrapper">
            <YouTubeVideo id={task.VIDEO[0].$.id} alt={task.VIDEO[0].$.alt} />
          </div>
        }


        <div className={`task__options${completed ? ' task__options--completed' : '' }`}>
          {
            task.OPTION.map((opt, i) => (
              
              task.$.type === TASK_TYPES.MCIA ?
                <MultipleChoiceImageOption 
                  key={i} 
                  name={task.$.id}
                  activeRadio={activeRadio}
                  completed={completed}
                  getOptionMods={getOptionMods}
                  option={opt} 
                  index={i}
                  handleChange={handleChange} 
                />

              :
                <MultipleChoiceOption 
                  key={i} 
                  name={task.$.id}
                  activeRadio={activeRadio}
                  completed={completed} 
                  getOptionMods={getOptionMods} 
                  option={opt} 
                  index={i}
                  handleChange={handleChange} 
                />
              
            ))
          }
        </div>

      </fieldset>

    </>
  )
}
  